import { render, staticRenderFns } from "./EditBalance.vue?vue&type=template&id=dcede190&scoped=true&"
import script from "./EditBalance.vue?vue&type=script&lang=js&"
export * from "./EditBalance.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dcede190",
  null
  
)

export default component.exports